import React, { isValidElement } from 'react';
import { Placement } from 'react-bootstrap/types';
import { ElementWithTooltipOrig } from './ElementWithTooltipOrig';
import 'src/components/common/vx/css/TooltipPopover.css';
export type ElementWithTooltipProps = {
  element: React.JSX.Element;
  tooltip: React.JSX.Element;
  placement?: Placement;
};

export function ElementWithTooltip({ element, tooltip, placement }: ElementWithTooltipProps) {
  const safeElement =
    isValidElement(element) && typeof element.type === 'string' ? element : <span>{element}</span>;

  return (
    <ElementWithTooltipOrig
      element={safeElement}
      tooltip={tooltip}
      placement={placement}
    />
  );
}
